import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'bg-system-gray-100 w-full scroll-mt-[calc(var(--head-fixed-height-1,172px)+16px)] max-lg:scroll-mt-[calc(var(--head-fixed-height,64px)+16px)] max-md:scroll-mt-[calc(var(--head-fixed-height,48px)+16px)] max-sm:-mr-3 max-sm:-ml-3 max-sm:w-[calc(100%+24px)] max-sm:px-3 max-sm:py-12 sm:px-5 sm:py-12',
    notEmpty: 'sm:pt-20',
    header:
      'relative mb-12 grid grid-cols-1 gap-6 max-sm:mt-2 max-sm:mb-8 max-sm:gap-0 lg:grid-cols-2',
    tabsContainer: 'flex items-center justify-between',
    mobileButton: 'flex size-10 items-center justify-center lg:hidden',
    button:
      'order-4 w-full max-sm:w-full sm:w-60 md:absolute md:right-0 md:bottom-2 lg:order-0 lg:mt-0 lg:w-70 lg:justify-self-end',
    reviewsHeader: 'col-span-2 mt-0 lg:mb-0',
    contentWrapper: 'flex w-full flex-col gap-6',
    footerButton:
      'bg-bg-items-white heading-s mt-12 flex h-12 w-full cursor-pointer items-center justify-center gap-6 font-[450] tracking-wider uppercase max-sm:mt-6',
    emptyTitle: 'flex items-center justify-center gap-4 max-md:gap-2',
    emptyTitleIcon: '[&>path]:fill-brand-400 h-5 w-5',
    arrowWrapper:
      'flex h-10 w-10 items-center justify-center rounded-[100px] border',
    iconArrow: 'h-[10px] w-[16px]'
  }
});
